import React from "react";
import PricingSlider from "../../../sections/BusinessDashboard/Subscriptions/PricingPlans/PricingSlider";
import { AdminPageTitle } from "../../../sections/AdminDashboard/shared/adminUx";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import { BUSINESS_CENTERED_PAGE_TITLE_CLASS } from "../../../sections/BusinessDashboard/shared/businessLayoutSpec";

const PricingPlans = () => {
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${BUSINESS_CENTERED_PAGE_TITLE_CLASS}`}>
        Pricing plans
      </AdminPageTitle>
      <div className="mx-auto min-h-screen">
        <PricingSlider />
      </div>
    </DashboardMainContainer>
  );
};

export default PricingPlans;
